// 菜单模块多语言配置
export const menu = {
  'zh-CN': {
    dashboard: '工作台',
    customer: '客户管理',
    order: '订单管理',
    merchandise: '商品管理',
    marketing: '营销活动',
    referral: '转介绍管理',
    finance: '财务管理',
    agent: '代理企业',
    video: '短视频管理',
    valueAdded: '增值服务',
    sharing: '分享推广管理',
    miniprogram: '前端设置',
    settings: '系统设置',
    // 侧边栏菜单项
    customerList: '客户列表',
    customerManagement: '客户管理',
    customerAdd: '客户录入',
    totalCustomer: '总客户池',
    businessManagement: '企业管理',
    customerImport: '客户导入',
    orderList: '订单列表',
    orderAdd: '添加订单',
    marketingList: '营销活动',
    marketingAdd: '添加活动',
    financeList: '财务记录',
    financeAdd: '添加记录',
    systemSettings: '系统设置',
    userManagement: '用户管理',
    roleManagement: '角色管理',
    // 企业管理子菜单
    corporateInfo: '企业信息',
    enterpriseMember: '企业成员',
    performanceAssessment: '成员考核',
    advancedForm: '高级表单',
    advertising: '广告图管理',
    // 商品管理子菜单
    merchandiseManagement: '商品管理',
    appointmentManagement: '预约管理',
    // 营销活动子菜单
    distribution: '分销',
    distributionStatistics: '分销统计',
    personnelApplication: '人员申请',
    distributionLevel: '分销等级',
    distributionOrder: '分销订单',
    normalOrder: '普通订单',
    groupBuyOrder: '拼团订单',
    accountTransfer: '到账流水',
    groupBuy: '拼团',
    productList: '拼团商品列表',
    participantsList: '参团列表',
    flashSale: '秒杀',
    flashSaleList: '秒杀商品列表',
    couponManagement: '优惠券管理',
    couponList: '优惠券列表',
    // 转介绍管理子菜单
    partnerList: '合作伙伴列表',
    rulesSetting: '规则设置',
    withdrawalList: '提现列表',
    // 财务管理子菜单
    financialStatistics: '财务统计',
    commissionManagement: '佣金管理',
    accountManagement: '账户管理',
    // 获客文章管理子菜单
    customerArticles: '获客文章',
    employeeData: '员工数据',
    visitorData: '访客数据',
    // 增值服务子菜单
    myNeeds: '我的需求',
    demandCheck: '需求审核',
    contactsCheck: '人脉集市审核',
    productsCheck: '产品中心审核',
    publishSetting: '发布设置',
    reportHandling: '举报处理',
    customizeSetting: '自定义设置',
    // 分享推广管理子菜单
    posterAtlas: '海报图集',
    clockData: '打卡数据',
    // 小程序设置子菜单
    appletConfig: '基础设置',
    basicSetting: '小程序配置',
    mallSetting: '商城设置',
  
  },
  'zh-TW': {
    dashboard: '工作台',
      customer: '客戶管理',
      order: '訂單管理',
      merchandise: '商品管理',
      marketing: '營銷活動',
      referral: '轉介紹管理',
      finance: '財務管理',
      agent: '代理企業',
      video: '短視頻管理',
      valueAdded: '增值服務',
      sharing: '分享推廣管理',
      miniprogram: '前端設置',
      settings: '系統設置',
      // 側邊欄菜單項
      customerList: '客戶列表',
      customerManagement: '客戶管理',
      customerAdd: '客戶錄入',
      totalCustomer: '總客戶池',
      businessManagement: '企業管理',
      customerImport: '客戶導入',
      orderList: '訂單列表',
      orderAdd: '添加訂單',
      marketingList: '營銷活動',
      marketingAdd: '添加活動',
      financeList: '財務記錄',
      financeAdd: '添加記錄',
      systemSettings: '系統設置',
      userManagement: '用戶管理',
      roleManagement: '角色管理',
      // 企業管理子菜單
      corporateInfo: '企業信息',
      enterpriseMember: '企業成員',
      performanceAssessment: '成員考核',
      advancedForm: '高級表單',
      advertising: '廣告圖管理',
      // 商品管理子菜單
      merchandiseManagement: '商品管理',
      appointmentManagement: '預約管理',
      // 營銷活動子菜單
      distribution: '分銷',
      distributionStatistics: '分銷統計',
      personnelApplication: '人員申請',
      distributionLevel: '分銷等級',
      distributionOrder: '分銷訂單',
      normalOrder: '普通訂單',
      groupBuyOrder: '拼團訂單',
      accountTransfer: '到賬流水',
      groupBuy: '拼團',
      productList: '拼團商品列表',
      participantsList: '參團列表',
      flashSale: '秒殺',
      flashSaleList: '秒殺商品列表',
      couponManagement: '優惠券管理',
      couponList: '優惠券列表',
      // 轉介紹管理子菜單
      partnerList: '合作夥伴列表',
      rulesSetting: '規則設置',
      withdrawalList: '提現列表',
      // 財務管理子菜單
      financialStatistics: '財務統計',
      commissionManagement: '佣金管理',
      accountManagement: '賬戶管理',
      // 獲客文章管理子菜單
      customerArticles: '獲客文章',
      employeeData: '員工數據',
      visitorData: '訪客數據',
      // 增值服務子菜單
      myNeeds: '我的需求',
      demandCheck: '需求審核',
      contactsCheck: '人脈集市審核',
      productsCheck: '產品中心審核',
      publishSetting: '發布設置',
      reportHandling: '舉報處理',
      customizeSetting: '自定義設置',
      // 分享推廣管理子菜單
      posterAtlas: '海報圖集',
      clockData: '打卡數據',
      // 小程序設置子菜單
      appletConfig: '基礎設置',
      basicSetting: '小程序配置',
      mallSetting: '商城設置',

  },
  'en': {
    dashboard: 'Dashboard',
      customer: 'Customer Management',
      order: 'Order Management',
      merchandise: 'Merchandise Management',
      marketing: 'Marketing Activities',
      referral: 'Referral Management',
      finance: 'Financial Management',
      agent: 'Agent Enterprise',
      video: 'Short Video Management',
      valueAdded: 'Value Added Services',
      sharing: 'Sharing Promotion',
      miniprogram: 'Frontend Settings',
      settings: 'System Settings',
      // Sidebar menu items
      customerList: 'Customer List',
      customerManagement: 'Customer Management',
      customerAdd: 'Customer Input',
      totalCustomer: 'Total Customer Pool',
      businessManagement: 'Enterprise Management',
      customerImport: 'Import Customer',
      orderList: 'Order List',
      orderAdd: 'Add Order',
      marketingList: 'Marketing Activities',
      marketingAdd: 'Add Activity',
      financeList: 'Financial Records',
      financeAdd: 'Add Record',
      systemSettings: 'System Settings',
      userManagement: 'User Management',
      roleManagement: 'Role Management',
      // Enterprise Management Submenu
      corporateInfo: 'Enterprise Information',
      enterpriseMember: 'Enterprise Members',
      performanceAssessment: 'Performance Assessment',
      advancedForm: 'Advanced Forms',
      advertising: 'Advertising Management',
      // Merchandise Management Submenu
      merchandiseManagement: 'Merchandise Management',
      appointmentManagement: 'Appointment Management',
      // Marketing Activities Submenu
      distribution: 'Distribution',
      distributionStatistics: 'Distribution Statistics',
      personnelApplication: 'Personnel Application',
      distributionLevel: 'Distribution Level',
      distributionOrder: 'Distribution Orders',
      normalOrder: 'Normal Orders',
      groupBuyOrder: 'Group Buy Orders',
      accountTransfer: 'Account Transfer',
      groupBuy: 'Group Buy',
      productList: 'Group Buy Product List',
      participantsList: 'Participants List',
      flashSale: 'Flash Sale',
      flashSaleList: 'Flash Sale Product List',
      couponManagement: 'Coupon Management',
      couponList: 'Coupon List',
      // Referral Management Submenu
      partnerList: 'Partner List',
      rulesSetting: 'Rules Setting',
      withdrawalList: 'Withdrawal List',
      // Financial Management Submenu
      financialStatistics: 'Financial Statistics',
      commissionManagement: 'Commission Management',
      accountManagement: 'Account Management',
      // Customer Articles Management Submenu
      customerArticles: 'Customer Articles',
      employeeData: 'Employee Data',
      visitorData: 'Visitor Data',
      // Value Added Services Submenu
      myNeeds: 'My Needs',
      demandCheck: 'Demand Check',
      contactsCheck: 'Contacts Check',
      productsCheck: 'Products Check',
      publishSetting: 'Publish Setting',
      reportHandling: 'Report Handling',
      customizeSetting: 'Customize Setting',
      // Sharing Promotion Submenu
      posterAtlas: 'Poster Atlas',
      clockData: 'Clock Data',
      // Mini Program Settings Submenu
      appletConfig: 'Basic Settings',
      basicSetting: 'Mini Program Config',
      mallSetting: 'Mall Settings'
  }
}; 